function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".fri-frakt-thin_svg__st0{fill:none;stroke:currentColor;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "fri-frakt-thin_svg__st0",
  d: "M6 11.7L.2 8.5V3.4L6 6.6zm-2.8-10l5.7 3.2m2.8 3.6V3.4L6 6.6v5.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "fri-frakt-thin_svg__st0",
  d: "M.2 3.4L6 .2l5.7 3.2"
});

function SvgFriFraktThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fri-frakt-thin_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.9 11.9",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFriFraktThin;